
import { HashRouter } from 'react-router-dom';
import './App.css';
import { AppRoutes } from './core/lib/AppRouting/routes';

function App() {
  return (
   <main >
   <HashRouter>
    <AppRoutes/>
   </HashRouter>
   </main>
  );
}

export default App;
